import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoverageModal } from '@app/my-zone/shared/modals/coverage-modal/coverage-modal';
import { CoverageIdEnum, NewModal, PolicyProductIdEnum } from 'outshared-lib';
import { Subscription } from 'rxjs';
import { CoverageGroupRadio, CoverageInput } from '../../classes';
import { coverageVehicleData } from '../../data';
import { CoverageGroupIdEnum } from '../../enums';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TooltipModule } from '@app/shared/tooltip/tooltip.module';
import { WucLinkModule } from '@inshared/website-ui-components';
import { DecimallizeDirective, DecimallizeModule } from '@inshared/shared/util-directives';

@Component({
    selector: 'ins-coverage-radio',
    templateUrl: 'coverage-radio.component.html',
    styleUrls: ['./coverage-radio.component.scss'],
    standalone: true,
    imports: [
       NgClass,
       NgIf,
       NgFor,
       TooltipModule,
       FormsModule,
       DecimallizeModule,
       WucLinkModule
    ],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CoverageRadioComponent),
      multi: true,
    }],
})
export class CoverageRadioComponent implements ControlValueAccessor, OnDestroy {

    static nextId = 0;
    private subscriptions = new Subscription();

    @Input() public group: CoverageGroupRadio;

    public coverageIdEnum: typeof CoverageIdEnum;
    public coverageGroupIdEnum: typeof CoverageGroupIdEnum;
    public coverageVehicleData;
    public policyProductIdEnum = PolicyProductIdEnum;
    public active: boolean = false;
    public selectedIndex: string;
    public id: number;
    public propagateChange;
    public value: { choice: string[] } = {
        choice: [],
    };

    constructor(
        private modalService: NewModal,
    ) {
        this.id = CoverageRadioComponent.nextId++;
        this.coverageVehicleData = coverageVehicleData;
        this.coverageIdEnum = CoverageIdEnum;
        this.coverageGroupIdEnum = CoverageGroupIdEnum;
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public writeValue(coverageIds: CoverageIdEnum[]): void {
        if (coverageIds && coverageIds.length > 0) {
            this.value.choice = coverageIds;
            this.selectedIndex = this.findSelectedIndex(coverageIds);
        }
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = () => {
            fn(this.value.choice);
        };
    }

    public registerOnTouched(): void {
        return;
    }

    public setSelected(input: CoverageInput): void {
        if (!input.acceptance) {
           return;
        }

        this.selectedIndex = input.id;
        this.value.choice = input.coverageIds;
        this.propagateChange();
    }

    public openModal(coverageInput: CoverageInput): boolean {
        const modalRef = this.modalService.open(CoverageModal);
        modalRef.componentInstance.coverageInput = coverageInput;

        return false;
    }

    private findSelectedIndex(coverageIds: CoverageIdEnum[]): string {
        const foundInput = this.group.inputs
            .find((input) => JSON.stringify(input.coverageIds) === JSON.stringify(coverageIds));

        if (!foundInput) {
            return '';
        }

        return foundInput.id;
    }
}
